<template>
  <div class="coupon-page">
    <div class="page-header">
      <i class="iconfont icon-back" @click="goBack">&#xe615;</i>
      <div class="page-title">我的卡券</div>
      <i class="iconfont"></i>
    </div>
    <div class="swiper-tab">
      <div @click="filterBy(item.code)" :class="[statusCode == item.code ? 'active' : '', 'swiper-tab-list']"
        v-for="(item, index) in states" :key="index">
        {{ item.text }}
      </div>
    </div>
    <div v-if="commonConfig['COUPON_LIST_TIP']" class="coupon-list-tip">{{ commonConfig['COUPON_LIST_TIP'] }}</div>
    <div v-if="pointsList.length" class="coupons-list">
      <div class="coupons-ul">
        <div :class="[item.status === 'expiredAndInvalid' || item.status === 'used' ? 'is-gray' : '', 'coupons-li']"
          v-for="(item, index) in pointsList" :key="index">
          <div class="li-top">
            <div class="t-info">
              <div class="title">{{ item.title }}-{{ item.type }}</div>
              <div class="tip-list">
                <span v-if="item.status === 'unused'" class="tip is-primary" @click="wxDialogShow = true">赠送好友</span>
                <span v-else-if="item.status === 'used'" class="tip">已使用</span>
                <span v-else-if="item.status === 'expiredAndInvalid'" class="tip">已过期</span>
              </div>
            </div>
            <div class="t-time">有效期：{{ item.start_time.split(' ')[0] }} 至 {{ item.end_time.split(' ')[0] }}</div>
          </div>
          <div class="li-bottom">
            <div class="b-l">使用渠道：{{ item.available_channel_type }}</div>
            <div class="b-r" @click="openDetailDialog(item)">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="no-order">
        <div class="no-info">
          <div class="icon-wrapper">
            <i class="iconfont-ot-website">&#xe6d9;</i>
          </div>
          <div class="no-txt">
            <div class="no-title">暂无相关优惠券</div>
          </div>
        </div>
        <div class="buy" @click="goShopping">去购物</div>
      </div>
    </div>
    <el-dialog custom-class="coupon-detail-dialog" :visible.sync="detailDialogShow" :close-on-click-modal="false"
      :close-on-press-escape="false" top="0">
      <div class="title">优惠券详情</div>
      <div class="detail">
        <div class="code">
          <div class="barcode">
            <img :src="barcodeDataURL" class="barcode-img" alt="barcode-img" />
            <span class="qrcode-value">{{ couponItem.coupon_code }}</span>
          </div>
          <div class="qrcode">
            <img :src="qrcodeDataURL" class="qrcode-img" alt="qrcode-img" />
            <span class="qrcode-value">结账前请向店员展示此优惠券</span>
          </div>
        </div>
        <div v-if="couponItem.start_time && couponItem.end_time" class="date com-font"> 有效期：{{
          couponItem.start_time.split(' ')[0] }} 至
          {{ couponItem.end_time.split(' ')[0] }}</div>
        <div class="tips">
          <span class="com-font">优惠券说明</span>
          <div class="">{{ detail.usage_note }}</div>
        </div>
      </div>
    </el-dialog>
    <WXUserCenter :show="wxDialogShow" :data="sendCouponDialogData" @updateShow="updateShow" />
  </div>
</template>
<script>
import api from "@/utils/api";
import types from "@/store/types";
import WXUserCenter from "@/components/WXUserCenter.vue";
import utils from "@/utils";
import QRCode from "qrcode";
import JsBarcode from "jsbarcode";
import { captureManualError } from '@/sentry/index'

export default {
  components: { WXUserCenter },
  data() {
    return {
      detailDialogShow: false, // 优惠券详情弹框
      wxDialogShow: false, // 赠送优惠券详情弹框
      qrcodeDataURL: "", // 二维码base64
      barcodeDataURL: "", // 条形码base64
      couponItem: {}, // 优惠券项
      states: [
        {
          text: "全部",
          id: "1",
          code: ''
        },
        {
          text: "未使用",
          id: "2",
          code: 'unused'
        },
        {
          text: "已使用",
          id: "3",
          code: 'used'
        },
        {
          text: "已过期",
          id: "4",
          code: 'expiredAndInvalid'
        },
      ],
      statusCode: "",
      size: 1000,
      total: 0,
      page: 1,
      pointsList: [],
      detail: []
    };
  },
  created() {
    this.loadSource();
  },

  methods: {
    goBack() {
      this.$router.push({ path: "/account" });
    },
    goShopping() {
      this.$router.push({ path: "/" });
    },
    // 状态过滤
    filterBy(code) {
      this.statusCode = code;
      this.page = 1;
      this.loadSource();
    },
    loadSource() {
      let { page, statusCode, size } = this;
      api[types.GET_COUPON_LIST]({ page, page_size: size, status: statusCode })
        .then((res) => {
          if (res?.code == 1) {
            let { data = [], randFromTotal = 0 } = res?.data;
            this.pointsList = data;
            this.total = randFromTotal;
          } else {
            console.warn(res);
          }
        })
        .catch((err) => {
          console.warn(err);
          captureManualError(err)
        });
    },
    // 页码变更
    goPage({ currPage }) {
      this.page = currPage;
      this.loadSource();
    },
    openDetailDialog(item) {
      // 调详情接口
      api[types.GET_COUPON_DETAIL]({ coupon_id: item.coupon_id }).then((res) => {
        if (res?.code === 1) {
          let { data = {} } = res;
          this.detail = data
          this.detailDialogShow = true;
          this.couponItem = item;
          QRCode.toDataURL(item.coupon_code, {
            width: 144,
            height: 144,
            margin: 0,
          })
            .then((url) => {
              this.qrcodeDataURL = url;
            })
            .catch((err) => {
              console.error(err);
              captureManualError(err)
            });

          const canvas = document.createElement("canvas");
          JsBarcode(canvas, "4NHFHISHOHIHF8AP", {
            format: "CODE128", // 条形码格式
            displayValue: false, // 是否显示条形码值
          });
          const barcodeDataURL = canvas.toDataURL();
          this.barcodeDataURL = barcodeDataURL;
        }
      })
    },

    // 更新弹框visible
    updateShow(value) {
      this.wxDialogShow = value
    }
  },

  computed: {
    sendCouponDialogData() {
      const isBr = utils.isMobile() && utils.isWXBrowser() ? '<br>' : ''
      const describe = `请前往Onitsuka Tiger鬼塚虎官方线上店${isBr}赠送好友优惠券`;
      return {
        title: '赠送好友',
        describe: describe,
        imgUrl: 'https://assetsprod.onitsukatiger.com/assets/wechat/usergw/user-coupon-list.png'
      };
    },
    commonConfig() {
      return this.$store.state.commonConfig;
    },
  },
};
</script>

<style lang="scss" scoped>
.coupon-page {
  .page-header {
    box-sizing: border-box;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    position: relative;

    .icon-back {
      color: #bcbcbc;
      line-height: 40px;
      width: 40px;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
      display: none;
    }

    .page-title {
      font-size: 20px;
      color: #2d2d2d;
      line-height: 40px;
      text-align: center;
    }
  }

  .coupon-list-tip {
    text-align: left;
    padding-bottom: 10px;
  }

  .swiper-tab {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
    font-size: 14px;
    margin-bottom: 20px;
    margin-top: 10px;
    border-bottom: 1px solid #b3b3b3;
    padding-bottom: 16px;

    .active {
      color: #333;
      font-size: 18px;
      border-right: 1px solid #333;
    }

    .swiper-tab-list {
      padding: 0 10px;
      height: 100%;
      text-align: center;
      border-right: 1px solid #666;
      cursor: pointer;

      &:last-child {
        border-right: none;
      }
    }
  }

  .no-order {
    display: flex;
    border: 1px solid #d2d2d2;
    justify-content: space-between;
    align-items: center;
    height: 210px;
    padding: 0 80px;
    box-sizing: border-box;

    .no-info {
      display: flex;
      align-items: center;

      .icon-wrapper {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        background-color: #fbfbfb;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;

        .iconfont-ot-website {
          font-size: 40px;
          color: #dfdfdf;
        }
      }

      .no-txt {
        display: flex;
        flex-direction: column;
        margin-left: 15px;

        .no-title {
          color: #333;
          font-size: 20px;
        }

        .no-subtitle {
          color: #666;
          font-size: 14px;
        }
      }
    }

    .buy {
      width: 100px;
      height: 26px;
      line-height: 26px;
      font-size: 12px;
      box-sizing: border-box;
      background: #7f0019;
      color: #fff;
      margin-bottom: 8px;
    }
  }

  .coupons-list {
    width: 100%;

    .coupons-ul {
      display: grid;
      grid-gap: 24px;

      .coupons-li {
        display: flex;
        border: 1px solid #333333;
        padding: 12px;
        box-sizing: border-box;
        flex-direction: column;

        .li-top {
          border-bottom: 1px dashed #eee;
          margin-bottom: 10px;
          display: flex;
          flex-direction: column;
          gap: 4px;
          padding-bottom: 12px;

          .t-info {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            gap: 4px;

            .title {
              color: #212322;
              text-align: left;
            }

            .is-used {
              color: #666666;
            }

            .tip-list {
              display: flex;
              gap: 10px;
              align-items: flex-start;
              flex-shrink: 0;

              .tip {
                font-size: 10px;
                line-height: 16px;
                display: block;
                padding: 1px 8px;
                border-radius: 24px;
                background: #e7e8ea;
              }

              .is-primary {
                background: #212322;
                color: #fff;
              }
            }
          }

          .t-time {
            color: #bfc0c4;
            font-size: 14px;
            line-height: 20px;
            text-align: left;
          }
        }

        .li-bottom {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          line-height: 1.2;

          .b-l {
            color: #666;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .b-r {
            color: #212322;
            white-space: nowrap;
            text-decoration: underline;
            cursor: pointer;
          }
        }

        &.is-gray {

          //置灰
          .title,
          .t-time,
          .b-l {
            color: #BFC0C4 !important;
          }
        }
      }
    }
  }

  ::v-deep .coupon-detail-dialog {
    top: 50%;
    transform: translateY(-50%);

    .el-dialog__body {
      padding: 0;
      position: relative;
    }

    .el-dialog__header {
      padding: 0;

      .el-dialog__headerbtn {
        top: 25px;
        right: 25px;
        z-index: 999;

        .el-icon-close {
          font-size: 24px;
          color: #000 !important;
        }
      }
    }

    .title {
      font-size: 18px;
      color: #212322;
      line-height: 20px;
      padding-bottom: 10px;
      position: absolute;
      left: 0;
      right: 0;
      background: #fff;
    }

    .detail {
      display: flex;
      flex-direction: column;
      overflow-y: scroll;
      padding: 44px 40px;

      .code {
        margin-top: 30px;

        img {
          margin: auto;
        }

        .qrcode {
          .qrcode-img {
            padding: 20px 0;
          }
        }

        .qrcode-value {
          color: #666666;
          font-size: 14px;
        }
      }

      .date {
        text-align: left;
        margin-top: 16px;
      }

      .tips {
        margin-top: 12px;
        text-align: left;
      }
    }

    .com-font {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .page-header {
      border-bottom: 1px solid #e7e7e7;

      .icon-back {
        display: block;
      }

      .page-title {
        font-size: 13px;
      }
    }
  }

  @media only screen and (max-width: 780px) {
    .coupons-ul {
      grid-template-columns: repeat(1, 100%);
    }

    ::v-deep .coupon-detail-dialog {
      width: calc(100% - 48px);

      .title {
        padding-top: 32px;
        font-size: 16px;
      }

      .detail {
        max-height: 612px;
        padding: 44px 20px;

        .code {
          .qrcode-value {
            font-size: 12px;
          }
        }
      }
    }

    .barcode-img {
      width: 100%;
      max-width: 450px;
      max-height: 80px;
    }

    .qrcode-img {
      width: calc(100% - 100px);
      max-width: 144px;
    }

    .no-order {
      height: auto;
      padding: 40px 30px;
      flex-direction: column;
      justify-content: flex-start;

      .no-info {
        flex-direction: column;

        .no-txt {
          margin: 20px 0 0 0;
        }
      }

      .buy {
        margin-top: 60px;
        width: 90%;
        height: 40px;
        line-height: 40px;
      }
    }
  }

  @media only screen and (min-width: 780px) {
    .coupons-ul {
      grid-template-columns: repeat(2, calc(50% - 12px));
    }

    ::v-deep .coupon-detail-dialog {
      width: 680px;

      .title {
        padding-top: 44px;
      }

      .detail {
        max-height: calc(100vh - 300px);
      }
    }

    .barcode-img {
      width: calc(100% - 240px);
      height: 80px;
    }

    .qrcode-img {
      width: 184px;
      height: 184px;
    }
  }

  .el-dialog {
    .detail {
      &::-webkit-scrollbar {
        width: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #888;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
      }
    }
  }
}
</style>
